<template>
  <info-form>
    <ButtonCreate class="mt_m"/>
  </info-form>
</template>

<script>
import InfoForm from '@/components/Info/Form'
import ButtonCreate from '@/components/Info/ButtonCreate'

export default {
  components: {
    InfoForm,
    ButtonCreate
  },

  created: async function () {
    this.$store.dispatch('info/resetForm')
  }
}
</script>
